module.exports = __webpack_public_path__ + "static/media/android.cbae359e.svg";